import { compose } from 'redux';

type DevtoolsConfig = {
	name?: string;
	instanceId?: string;
	trace?: boolean;
	traceLimit?: number;
};

// An extended version of redux's 'compose' method, that
// will use redux devtools chrome extension if available
// https://github.com/zalmoxisus/redux-devtools-extension
//
// The 'devtoolsConfig' parameter is an object adhering to the following API:
// https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (devtoolsConfig: DevtoolsConfig = {}) => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const devtoolsEnhancer = __SERVER__ ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
	const config = { ...devtoolsConfig };
	if (config.name != null && config.instanceId == null) {
		config.instanceId = config.name;
	}
	if (process.env.NODE_ENV === 'production') {
		return compose;
	}
	return devtoolsEnhancer ? devtoolsEnhancer(devtoolsConfig) : compose;
};
